function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/** @preserve
   * Ⓒ Allstate 2024.
   * Component Library v2.79.1.
   */
import { css } from '@emotion/react';
import { rem } from '../../functions/units';

// eslint-disable-next-line complexity, sonarjs/cyclomatic-complexity
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1vg1pao",
  styles: "border:0;font-family:inherit;font-size:100%;margin:0;outline:none;padding:0;vertical-align:baseline;display:block"
} : {
  name: "7itvn5-reset",
  styles: "border:0;font-family:inherit;font-size:100%;margin:0;outline:none;padding:0;vertical-align:baseline;display:block;label:reset;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "2moo71",
  styles: "border:0;font-family:inherit;font-size:100%;margin:0;outline:none;padding:0;vertical-align:baseline;border-collapse:collapse;border-spacing:0"
} : {
  name: "qfw4eb-reset",
  styles: "border:0;font-family:inherit;font-size:100%;margin:0;outline:none;padding:0;vertical-align:baseline;border-collapse:collapse;border-spacing:0;label:reset;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "1p7yjef",
  styles: "border:0;font-family:inherit;font-size:100%;margin:0;outline:none;padding:0;vertical-align:baseline;list-style:none"
} : {
  name: "iezwh0-reset",
  styles: "border:0;font-family:inherit;font-size:100%;margin:0;outline:none;padding:0;vertical-align:baseline;list-style:none;label:reset;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref4 = process.env.NODE_ENV === "production" ? {
  name: "17lcq3v",
  styles: "border:0;font-family:inherit;font-size:100%;margin:0;outline:none;padding:0;vertical-align:baseline;quotes:none;&:before{content:'';content:none;}&:after{content:'';content:none;}"
} : {
  name: "14s5vss-reset",
  styles: "border:0;font-family:inherit;font-size:100%;margin:0;outline:none;padding:0;vertical-align:baseline;quotes:none;&:before{content:'';content:none;}&:after{content:'';content:none;};label:reset;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref5 = process.env.NODE_ENV === "production" ? {
  name: "8nfth5",
  styles: "border:0;font-family:inherit;font-size:100%;margin:0;outline:none;padding:0;vertical-align:baseline"
} : {
  name: "hz7vo1-reset",
  styles: "border:0;font-family:inherit;font-size:100%;margin:0;outline:none;padding:0;vertical-align:baseline;label:reset;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var reset = function reset(el) {
  switch (el) {
    case 'a':
    case 'abbr':
    case 'acronym':
    case 'address':
    case 'applet':
    case 'audio':
    case 'b':
    case 'big':
    case 'canvas':
    case 'caption':
    case 'center':
    case 'cite':
    case 'code':
    case 'dd':
    case 'del':
    case 'dfn':
    case 'div':
    case 'dl':
    case 'dt':
    case 'em':
    case 'embed':
    case 'fieldset':
    case 'form':
    case 'h1':
    case 'h2':
    case 'h3':
    case 'h4':
    case 'h5':
    case 'h6':
    case 'i':
    case 'iframe':
    case 'img':
    case 'ins':
    case 'kbd':
    case 'label':
    case 'legend':
    case 'li':
    case 'mark':
    case 'object':
    case 'output':
    case 'p':
    case 'pre':
    case 'ruby':
    case 's':
    case 'samp':
    case 'small':
    case 'span':
    case 'strike':
    case 'strong':
    case 'sub':
    case 'summary':
    case 'sup':
    case 'tbody':
    case 'td':
    case 'tfoot':
    case 'th':
    case 'thead':
    case 'time':
    case 'tr':
    case 'tt':
    case 'u':
    case 'var':
    case 'video:':
      {
        return _ref5;
      }
    case 'blockquote':
    case 'q':
      {
        return _ref4;
      }
    case 'ol':
    case 'ul':
      {
        return _ref3;
      }
    case 'table':
      {
        return _ref2;
      }
    case 'article':
    case 'aside':
    case 'details':
    case 'figure':
    case 'figcaption':
    case 'footer':
    case 'header':
    case 'hgroup':
    case 'menu':
    case 'nav':
    case 'section':
      {
        return _ref;
      }
    case 'input':
    case 'select':
    case 'textarea':
      {
        return /*#__PURE__*/css("&:-webkit-autofill{font-size:inherit;-webkit-text-fill-color:inherit;-webkit-box-shadow:", rem(0, 0, 0, 1000), " rgba(0, 0, 0, 0) inset;transition:background-color 5000s ease-in-out 0s;&:hover{font-size:inherit;-webkit-text-fill-color:inherit;-webkit-box-shadow:", rem(0, 0, 0, 1000), " rgba(0, 0, 0, 0) inset;transition:background-color 5000s ease-in-out 0s;}&:focus{font-size:inherit;-webkit-text-fill-color:inherit;-webkit-box-shadow:", rem(0, 0, 0, 1000), " rgba(0, 0, 0, 0) inset;transition:background-color 5000s ease-in-out 0s;}}" + (process.env.NODE_ENV === "production" ? "" : ";label:reset;"));
      }
  }
};
export default reset;